import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application.js';
import { BudgetHeadCreationBlue32, Cancel32, submit } from '../../../../../public/LoginImages/importimages';

// 27-10 for cal
const pad = (n) => String(n).padStart(2, "0");

const toLocalInput = (value) => {
  if (!value) return "";
  const d =
    value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const getCurrentDateTime = () => toLocalInput(new Date());

const FundCreation = ({
  isEdit = false,
  fundData,
  onSuccess,
  onCancel
}
) => {
  const operation = useContext(Application);
  const { FundCreation } = operation;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ Year: "", GRNumber: "", LetterNumber: "", Date: "", UTRNumber: "", BANKUTRDate: "", FundAmount: "", UploadCopy: null });
  const [IsEdit, setIsEdit] = useState(null);
  const [EditFundId, setEditFundId] = useState(null);
const [errors, setErrors] = useState({});
  useEffect(() => {

    if (isEdit && fundData) {
      console.log("fundData:", fundData);
      setData({
        FundID: fundData.FundID,
        Year: fundData.Year || "",
        GRNumber: fundData.GRNumber || "",
        LetterNumber: fundData.LetterNumber || "",
        Date: fundData.Date ? fundData.Date.slice(0, 16) : "",
        UTRNumber: fundData.UTRNumber || "",
        BankUTRDate: fundData.BankUTRDate
          ? fundData.BankUTRDate.slice(0, 16)
          : "",
        FundAmount: fundData.FundAmount || "",
        UploadCopy: null
      });

    }

  }, [isEdit, fundData]);
  const HandleChangeData = (e) => {
    const { name, value, files } = e.target;
    // 30-09
    if (name === "Date" || name === "BankUTRDate") {
    const year = value.split("-")[0];
    if (year.length > 4) {
      return;
    }
    if (year && !/^\d{1,4}$/.test(year)) {
      return;
    }
  }
    // setData((prev) => ({ ...prev, [name]: files && files.length > 0 ? files[0] : value }));
 setData((prev) => ({
  ...prev,
  [name]: files && files.length > 0 ? files[0] : value,
}));
 
 
setErrors((prev) => ({
  ...prev,
  [name]: "",
}))
    // 08-10 
  };
  console.log(data.UploadCopy);

 // 27-10
const handleDateTimeChange = (e) => {
  const input = e.target;
  const { name, value } = input;

  const prevDate = toLocalInput(data[name]).split("T")[0];
  const newDate = (value || "").split("T")[0];

  HandleChangeData({ target: { name, value } });

  if (!newDate) return;

  // If the field was empty, compare against today (the picker opens on today)
  const baseline = prevDate || getCurrentDateTime().split("T")[0];

  const [py, pm, pd] = baseline.split("-").map(Number);
  const [ny, nm, nd] = newDate.split("-").map(Number);

  const monthChanged = py !== ny || pm !== nm;
  const daysInNewMonth = new Date(ny, nm, 0).getDate();

  // Month arrows keep the same day (or clamp it, e.g. 31 -> 30)
  const isArrowNavigation =
    monthChanged &&
    (pd === nd || (nd === daysInNewMonth && pd > daysInNewMonth));

  // Only the time was changed (same date as before)
  const isTimeOnly = prevDate && newDate === prevDate;

  // Close only when a date was actually clicked
  if (!isArrowNavigation && !isTimeOnly) {
    setTimeout(() => input.blur(), 0);
  }
};
  const handleFinalSubmit = async () => {
     const newErrors = {};
 
  if (!data.Year || data.Year === "null") {
    newErrors.Year = "Year is required";
  }
 
  if (!data.GRNumber?.trim()) {
    newErrors.GRNumber = "GR Number is required";
  }
 
  if (!data.LetterNumber?.trim()) {
    newErrors.LetterNumber = "Letter Number is required";
  }
 
  if (!data.Date) {
    newErrors.Date = "Date is required";
  }
 
  if (!data.UTRNumber?.trim()) {
    newErrors.UTRNumber = "UTR Number is required";
  }
 
  if (!data.BankUTRDate) {
    newErrors.BankUTRDate = "Bank UTR Date is required";
  }
 
  if (!data.FundAmount || Number(data.FundAmount) <= 0) {
    newErrors.FundAmount = "Fund Amount is required";
  }
 
  if (!data.UploadCopy) {
    newErrors.UploadCopy = "Upload Copy is required";
  }
 
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }
 
  setErrors({});
  setLoading(true);
 
 

    try {
      const formData = new FormData();

      formData.append("data", JSON.stringify(data));

      if (data.UploadCopy) {
        formData.append("UploadCopy", data.UploadCopy);
      }

      if (isEdit) {
        formData.append("type", "updateFundData");
      } else {
        formData.append("type", "createFundData");
      }

      // Call the same API for both Create and Update
      const result = await FundCreation(formData);

      console.log("API Response:", result);

      if (result.message) {
        alert(result.message);

        if (isEdit) {
          onSuccess();
        } else {
          window.location.reload();
        }
      }

    } catch (error) {
      console.error("Fund Submit Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const backBtn = {
    background: "#dc3545",
    color: "#fff",
    border: "none",
    // padding: "8px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    width: "60px",
    height: "27px",
    marginLeft:"10px"
 
  };


  // 05-10
    const handleCancel = () => {
    const confirmCancel = window.confirm(
      "Are you sure you want to cancel?"
    );
 
    if (!confirmCancel) {
      return;
    }
 
    setData({
      FundID: null,
      Year: "",
      GRNumber: "",
      LetterNumber: "",
      Date: "",
      UTRNumber: "",
      BankUTRDate: "",
      FundAmount: "",
      UploadCopy: null,
    });
 
    // Clear file input
    const fileInput = document.getElementById("UploadCopy");
    if (fileInput) {
      fileInput.value = "";
    }
 
    alert("Fund form cancelled successfully.");
 
    // If parent component has provided onCancel
    if (onCancel) {
      onCancel();
    }
  };
 
const errorStyle = {
  color: "#dc3545",
  fontSize: "12px",
  marginTop: "4px",
  display: "block",
  fontWeight: "500",
};
 
  return (
    <div  style={{
    width: "100%",
    minHeight: "90vh",
    background: "#ffffff",
    padding: "18px 20px 30px",
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
    overflowY: "auto",
    scrollbarWidth: "none"
  }}>
      {/* <div  style={{
    width: "100%",
    maxWidth: "790px",
    margin: "0 20px 10px",
    display: "flex",
    alignItems: "center",
    gap: "7px"
  }}>
        <img src={BudgetHeadCreationBlue32} style={{ height:"22px",width:"22px" }} ></img>
        <h5 style={{ margin: 0, color: "#111111", fontWeight: 700, fontSize: "18px" }}>  {isEdit ? "Update Fund" : "Add Fund"}</h5>
      </div> */}
      {/* commented for back btn --16-09 */}
       <div
  style={{
    width: "100%",
    maxWidth: "100%",
    // margin: "10px 20px 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Back button - ONLY for Update Fund */}
  {isEdit && (
    <button
      type="button"
 onClick={(e) => {
  e.preventDefault();
  e.stopPropagation();
 
  if (onCancel) {
    onCancel();
  }
}}
      style={backBtn}
    >  <span style={{ fontSize: "18px", alignItems:"center", justifyContent:"center", marginBottom:"20px" }}>←</span>
      Back
    </button>
  )}
 
  {/* Heading */}
  <div
    style={{
      // display: "flex",
      // // justifyContent: "center",
      // // alignItems: "center",
      // gap: "7px",
      // flex: 1,
      display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          background: "transparent",
          padding: "0",
          // marginRight: "20px",
          // marginLeft: "-30px",
          boxShadow: "none",
          width: "100%",
          // marginBottom: "10px",
          margin:"10px",
          marginTop:"20px",
          marginLeft:"30px"
    }}
  >
    <img
      src={BudgetHeadCreationBlue32}
      alt="Add Fund"
      style={{
        width: "22px",
        height: "22px",
      }}
    />
 
    <h5
      style={{
        margin: 0,
            color: "black",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "1.2",
      }}
    >
      {isEdit ? "Update Fund" : "Add Fund"}
    </h5>
  </div>
</div>
  {/* //30/10 */}
 <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "1000px", margin: "0 auto", width:"95%" }}>
      <form style={{ width:"100%", margin: 0 }}>
        <div
        style={{
  width: "100%",
  maxWidth: "950px",
  //30/10
  backgroundColor: "#EEF2F8",
        border: "1px solid #dde3ee",
  borderRadius: "8px",
  padding: "25px 28px 28px",
  boxSizing: "border-box",
  margin: "0 auto"
}}
            >
          <div style={{
                display: "grid",
              gridTemplateColumns: "1fr 1fr",
              columnGap: "20px",
              rowGap: "14px",
              width: "100%"}}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px" ,fontSize:"14px"}}>Year</label>
              <select name="Year" value={data.Year} id="" className='py-2'
                style={{ border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px", width: "100%",boxSizing:"border-box",fontSize:"12px",height:"40px" }} onChange={HandleChangeData}>
                <option value="null">Choose Year</option>
                <option value="2024-2025">2024 - 2025</option>
                <option value="2025-2026">2025 - 2026</option>
                <option value="2026-2027">2026 - 2027</option>
              </select>
              {errors.Year && (
  <span style={errorStyle}>{errors. Year}</span>
)}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px",fontSize:"14px" }}>GR Number</label>
              <input type='text' placeholder='Enter GR Number' style={{ border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px",width: "100%", height: "40px",  fontSize: "12px", boxSizing: "border-box" }} name='GRNumber' value={data.GRNumber} onChange={HandleChangeData} required />
     {errors.GRNumber && (
  <span style={errorStyle}>{errors.GRNumber}</span>
)}
 
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}>Letter Number</label>
              <input type="text" placeholder='Enter Letter Number'
                className='form-control py-2' style={{ border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px",width: "100%", height: "40px",  fontSize: "12px", boxSizing: "border-box" }} name='LetterNumber' value={data.LetterNumber} onChange={HandleChangeData} required />
                   {errors.LetterNumber && (
  <span style={errorStyle}>{errors.LetterNumber}</span>
)}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}>Date</label>
             {/* 27-10 */}
             <div  style={{ display: "flex", gap: "8px" }}>
  {/* Date */}
<input
  type="datetime-local"
  className="form-control py-2"
  name="Date"
  value={toLocalInput(data.Date)}
  max="9999-12-31T23:59"
  onChange={handleDateTimeChange}
  style={{
    border: "1px solid #c7c0c0",
    borderRadius: "10px",
    padding: "7px 10px",
    width: "100%",
    height: "40px",
    fontSize: "12px",
    boxSizing: "border-box",
  }}
/>
</div>
{errors.Date && (
  <span style={errorStyle}>{errors. Date}</span>
)}
 
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}>UTR Number</label>
              <input type='text' placeholder='Enter UTR Number' style={{ border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px",width: "100%", height: "40px",  fontSize: "12px", boxSizing: "border-box" }} name='UTRNumber' value={data.UTRNumber} onChange={HandleChangeData} required />
            
             {errors.UTRNumber && (
  <span style={errorStyle}>{errors.UTRNumber}</span>
)}</div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}>Bank UTR Date</label>
              <div  style={{ display: "flex", gap: "8px" }}>
             <input
  type="datetime-local"
  className="form-control py-2"
  name="BankUTRDate"
  value={toLocalInput(data.BankUTRDate)}
  max="9999-12-31T23:59"
  onChange={handleDateTimeChange}
  style={{
    border: "1px solid #c7c0c0",
    borderRadius: "10px",
    padding: "7px 10px",
    width: "100%",
    height: "40px",
    fontSize: "12px",
    boxSizing: "border-box",
  }}
/>
</div>
             {errors.BankUTRDate && (
  <span style={errorStyle}>{errors.BankUTRDate}</span>
)}
 
 
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label" style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}>Add Fund Amount</label>
              <input type='text' placeholder='Enter Fund Amount' style={{ border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px",width: "100%", height: "40px",  fontSize: "12px", boxSizing: "border-box" }} name='FundAmount'
  // value={data.FundAmount}
   value={ data.FundAmount ? Number(data.FundAmount).toLocaleString("en-IN")  : ""}
   onChange={(e) => { const value = e.target.value.replace(/[^0-9]/g, "");HandleChangeData({ target: { name: "FundAmount", value: value  }  }); }} required />
          {errors.FundAmount && (
  <span style={errorStyle}>{errors.FundAmount}</span>
)}
   
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label"
                style={{ fontWeight: "700", marginBottom: "10px", fontSize:"14px" }}> Upload Copy</label>
              <input type="file" className='form-control py-2' style={{ border: "1px solid #c7c0c0", borderRadius: "10px", padding: "7px 10px",width: "100%", height: "40px",  fontSize: "12px", boxSizing: "border-box" }} name="UploadCopy" id='UploadCopy' onChange={HandleChangeData} />
           
           {errors.UploadCopy && (
  <span style={errorStyle}>{errors.UploadCopy}</span>
)} </div>
          </div>
         <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    marginTop: "20px",
    width: "100%"
  }}>
        
    
       
            <button type='button' style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    borderRadius: "20px",
    width: "100px",
    height: "35px",
    //30/10
    backgroundColor:" rgb(46, 158, 79)",
    color: "#ffffff",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
  }}onClick={handleFinalSubmit}>
              <img src={submit} style={{ width: "14px",height:"14px",margin:0 }} /> {loading  ? (isEdit ? "Updating..." : "Submitting...") : (isEdit ? "Update" : "Submit")}</button>
         
            <button type="button" 
            onClick={handleCancel} //05-10
             style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    borderRadius: "6px",
    width: "85px",
    height: "35px",
    backgroundColor: "#f3372a",
    border: "none",
    fontSize: "12px",
    color: "#ffffff",
    fontWeight: "600",
    cursor: "pointer"
}} >
              <img src={Cancel32} style={{ height: '14px', width: '14px', margin:"0"}} />
              Cancel
            </button>
          </div>
    </div>
      </form>
      </div>
      </div>
  );
};

export default FundCreation;